import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalUtils } from '../utils/modal-utils';
import { AppOutOfDateModalComponent } from '../views/dashboard/components/app-out-of-date-modal/app-out-of-date-modal.component';

export class ModalAppOutOfDate {
  static open(ngZone: NgZone, ngbModal: NgbModal, injector: Injector, desc: string): void {
    ngZone.run(() => {
      const modalRef = ngbModal.open(AppOutOfDateModalComponent, ModalUtils.invalidAppVersionOptions(injector));
      (modalRef.componentInstance as AppOutOfDateModalComponent).viewModel.connectToDesc(desc);
    });
  }
}
